import {PuiSection} from "@portnet/ui";
import React from "react";

const AppSection = React.forwardRef((props, ref) => {
  return <PuiSection ref={ref} {...props} />;
});

export default AppSection;
